module.exports = __webpack_public_path__ + "media/images/icons/linkedin_white-149b156c69ad2a2e4af166c7451d98c8.svg";